// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1Ja7w","content":"RecentSearches_content__cyjLC"};